import { useContext } from "react";
import BadgeUnidade from "../../../../../../shared/components/badgeUnidade/BadgeUnidade";
import { AuthContext } from "../../../../../../shared/context/auth-context";
import { dadosImpressao } from "../../../../../../shared/util/dadosImpressao";
import "../List.scss";

//mui
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined"; //gerar Pdf
import DeleteIcon from "@mui/icons-material/Delete"; //Delete icon

//Antd
import { Popover } from "antd";
import { Popconfirm } from "antd";

function List(props) {
  const auth = useContext(AuthContext);

  const verPrescricao = (id) => {
    /* Compara por `_id` — ver a nota igual em `ListRequisicaoExames`. Este
       endpoint também devolve documentos do mongoose, sem o virtual `id`, e
       o filtro casava com todas as linhas: imprimia-se sempre a primeira
       prescrição da lista, independentemente da que se escolhesse. */
    const filteredPrescricao = props.data.filter((pres) => {
      return pres._id === id;
    });

    props.prescricaoData(
      filteredPrescricao[0].cliente,
      // A morada impressa é a da unidade onde o documento foi emitido, não a de
      // quem o está a reimprimir.
      dadosImpressao(
        filteredPrescricao[0].clinica,
        filteredPrescricao[0].estabelecimento,
      ),
      filteredPrescricao[0].medico,
      filteredPrescricao[0].prescricoes
    );
  };

  let content = [];
  if (props.data) {
    props.data.forEach((row) => {
      content.push(
        <div className="dots__menu__popup">
          {auth.perm.includes("d-pres") && row.medico._id === auth.userId && (
            <Popconfirm
              title="Desativar prescrição"
              description="Tem a certeza que pretende desativar a prescrição?"
              icon={<DeleteIcon style={{ color: "red" }} />}
              okText="Sim"
              cancelText="Não"
              onConfirm={props.handleDesativar.bind(null, row._id)}
            >
              <div className="popOverMenu--option">
                <span>Desativar</span>
                <DeleteIcon className="popOverMenu--option__icon" />
              </div>
            </Popconfirm>
          )}
        </div>
      );
    });
  }

  return (
    <>
      <TableContainer component={Paper} className="table">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead style={{ background: "#fff" }}>
            <TableRow>
              <TableCell className="tableCell tableCell--heading">
                Médico Responsável
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Data Prescrição
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>

          {props.data && (
            <TableBody>
              {props.data.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell className="tableCell">
                    {row.medico.name}
                    <BadgeUnidade estabelecimento={row.estabelecimento} />
                  </TableCell>
                  <TableCell className="tableCell">
                    {row.data_prescricao}
                  </TableCell>
                  <TableCell className="tableCell">
                    <div className="botoes-action">
                      {auth.perm.includes("r-pres") && !row.terminado && (
                        <Tooltip title="Gerar Pdf">
                          <PictureAsPdfOutlinedIcon
                            className="action-button-with-tooltip"
                            onClick={verPrescricao.bind(null, row._id)}
                            style={{ cursor: "pointer" }}
                          />
                        </Tooltip>
                      )}

                      {content[index] && (
                        <Popover
                          content={content[index]}
                          trigger="click"
                          placement="bottom"
                        >
                          <div className="dots__menu">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                          </div>
                        </Popover>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </>
  );
}

export default List;
